import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import Button from '../common/Button';
import * as FiIcons from 'react-icons/fi';

const { FiArrowUpRight } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 dark:bg-slate-950 text-white pt-24 pb-12 overflow-hidden relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-700 dark:via-slate-600 to-transparent opacity-50"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5 lg:col-span-4">
            <Link to="/" className="flex items-center space-x-3 mb-8 group">
              <div className="w-10 h-10 bg-white dark:bg-slate-800 rounded-lg flex items-center justify-center transition-transform duration-500 group-hover:rotate-12">
                <span className="text-slate-900 dark:text-white font-serif font-bold text-lg">TM</span>
              </div>
              <span className="font-serif font-bold text-2xl tracking-tight">Tom McKay</span>
            </Link>
            <p className="text-slate-400 dark:text-slate-500 leading-relaxed mb-8 max-w-sm">
              45+ years of real estate investing experience. Building generational wealth through proven mentorship.
            </p>
            <div className="flex space-x-4">
              <Button to="/onboarding" variant="white" className="text-sm px-6 py-3">
                Apply for Mentorship
              </Button>
            </div>
          </div>

          <div className="md:col-span-7 lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="font-serif font-semibold text-lg mb-6 text-white">Mentorship</h4>
              <ul className="space-y-4">
                <li><Link to="/mentorship" className="text-slate-400 hover:text-white transition-colors">All Programs</Link></li>
                <li><Link to="/mentorship#bronze" className="text-slate-400 hover:text-white transition-colors">Bronze</Link></li>
                <li><Link to="/mentorship#silver" className="text-slate-400 hover:text-white transition-colors">Silver</Link></li>
                <li><Link to="/mentorship#gold" className="text-slate-400 hover:text-white transition-colors">Gold</Link></li>
                <li><Link to="/mentorship#platinum" className="text-slate-400 hover:text-white transition-colors">Platinum</Link></li>
                <li><Link to="/book" className="text-slate-400 hover:text-white transition-colors flex items-center">Get the Book <SafeIcon icon={FiArrowUpRight} className="ml-1 w-3 h-3" /></Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-serif font-semibold text-lg mb-6 text-white">About</h4>
              <ul className="space-y-4">
                <li><Link to="/about" className="text-slate-400 hover:text-white transition-colors">About Tom</Link></li>
                <li><Link to="/success" className="text-slate-400 hover:text-white transition-colors">Success Stories</Link></li>
                <li><Link to="/shop" className="text-slate-400 hover:text-white transition-colors">Shop</Link></li>
                <li><Link to="/faq" className="text-slate-400 hover:text-white transition-colors">FAQ</Link></li>
                <li><Link to="/contact" className="text-slate-400 hover:text-white transition-colors">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-serif font-semibold text-lg mb-6 text-white">Legal</h4>
              <ul className="space-y-4">
                <li><Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">Privacy</Link></li>
                <li><Link to="/terms" className="text-slate-400 hover:text-white transition-colors">Terms</Link></li>
                <li><Link to="/disclaimer" className="text-slate-400 hover:text-white transition-colors">Disclaimer</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="flex justify-center gap-6 mb-10">
          <a href="https://www.youtube.com/@FlipAnythingUSA" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-slate-500 hover:text-white transition-colors duration-200">
            <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73" />
            </svg>
          </a>
          <a href="https://www.instagram.com/flipanythingusa" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-slate-500 hover:text-white transition-colors duration-200">
            <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3" />
            </svg>
          </a>
          <a href="https://twitter.com/flipanythingusa" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="text-slate-500 hover:text-white transition-colors duration-200">
            <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10.488 14.651L15.25 21h7l-7.858-10.478L20.93 3h-2.65l-5.117 5.886L8.75 3h-7l7.51 10.015L2.32 21h2.65zM16.25 19L5.75 5h2l10.5 14z" />
            </svg>
          </a>
          <a href="https://www.facebook.com/FlipAnythingUSA" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-slate-500 hover:text-white transition-colors duration-200">
            <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z" />
            </svg>
          </a>
        </div>

        <div className="border-t border-slate-800 dark:border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center text-slate-500 text-sm">
          <p>© {currentYear} Tom McKay. All rights reserved.</p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="https://flipanythingusa.com" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-white transition-colors">FlipAnythingUSA.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;